import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate, Link } from 'react-router-dom';
import Pagination from '../../components/layout/Pagination'

function Customers() {
  const API_URL = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem('authToken');
  const [customers, setCustomers] = useState([])
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortBy, setSortBy] = useState('');
  const [pageSize, setPageSize] = useState(10);
  const [searchedCustomer, setSearchedCustomer] = useState('');

  const location = useLocation()
  const navigate = useNavigate();

  useEffect(() => {
    fetchCustomers(searchedCustomer, sortBy, pageSize, currentPage)
  }, [location.search])

  const fetchCustomers = async (searchedCustomer, sortBy, pageSize, currentPage) => {
    try {
      setLoading(true)

      const response = await fetch(`${API_URL}/customer/customers?customerSearch=${searchedCustomer}&sortBy=${sortBy}&pageNumber=${currentPage}&pageSize=${pageSize}`, {
        method: 'GET',
        headers: {
          "Authorization": `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      })

      if (response.status === 401) {
        navigate('/');
      }

      const result = await response.json()

      if (result?.data?.customers) {
        const newQueryParams = new URLSearchParams(location.search);
        setCustomers(result.data.customers);
        setTotalPages(result.data.totalPages);
        setTotalItems(result.data.totalItems);
        setLoading(false)

        if (result.data.totalPages) {
          newQueryParams.set("totalPages", result.data.totalPages);
        }
        //navigate({ search: newQueryParams.toString() });
      } else {
        setCustomers([])
        setLoading(false)
      }
    }
    catch (error) {
    }
  }

  const handlePageSizeChange = (e) => {
    const newQueryParams = new URLSearchParams(location.search);
    newQueryParams.set('currentPage', '1');
    setCurrentPage(1);
    const { name, value } = e.target;

    if (value) {
      newQueryParams.set(name, value);
    } else {
      newQueryParams.delete(name); // Избриши ако нема вредност
    }
    setPageSize(e.target.value);

    navigate({ search: newQueryParams.toString() });
  };

  const handleSortByChange = (e) => {
    const newQueryParams = new URLSearchParams(location.search);
    const { name, value } = e.target;

    if (value) {
      newQueryParams.set(name, value);
    } else {
      newQueryParams.delete(name); // Избриши ако нема вредност
    }
    setSortBy(e.target.value);

    navigate({ search: newQueryParams.toString() });
  };

  const handlePageChange = (page) => {
    const newQueryParams = new URLSearchParams(location.search);

    if (page) {
      newQueryParams.set('currentPage', page);
    } else {
      newQueryParams.delete('currentPage');
    }
    navigate({ search: newQueryParams.toString() });

    setCurrentPage(page)
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSearchIconClick(); // Повикај ја функцијата ако е притиснат Enter
    }
    if(event.key === 'Escape'){
      clearInput();
    }
  };

  const handleSearchIconClick = () => {
    if (searchedCustomer.length > 0 && searchedCustomer.length < 4) {
      return;
    }
    fetchCustomers(searchedCustomer, sortBy, pageSize, currentPage);
  };

  const clearInput = () => {
    setSearchedCustomer('');
    fetchCustomers('', sortBy, pageSize, currentPage);
  };


  return (
    <div className="p-6">
      <div className='flex flex-col'>
        <div className='ml-auto'>
          <label htmlFor='pageSize'>Прикажи:</label>
          <select
            className="mb-4"
            name='pageSize'
            id='pageSize'
            value={pageSize}
            onChange={handlePageSizeChange}
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="50">50</option>
          </select>
        </div>
        <div className='ml-auto'>
          <select
            className="mb-4"
            name='sortBy'
            value={sortBy}
            onChange={handleSortByChange}
          >
            <option value="">Стандардно подредување</option>
            <option value="name">Име</option>
            <option value="email">Емаил</option>
            <option value="city">Град</option>
          </select>
        </div>
        <div className="flex items-center border border-gray-300 rounded-lg p-[1px] max-w-[180px] mr-1 tooltip" data-tip='Пребарувај по емаил или телефонски број'>
          <input
            type="text"
            className="flex-grow p-1 outline-none w-full"
            placeholder="Пребарувај корисници"
            value={searchedCustomer}
            onChange={(e) => setSearchedCustomer(e.target.value)}
            onKeyDown={handleKeyDown}
          />
          {searchedCustomer && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 16 16"
              fill="currentColor"
              className="h-5 w-5 text-gray-500 cursor-pointer"
              onClick={clearInput}
            >
              <path
                fillRule="evenodd"
                d="M11.03 4.97a1 1 0 0 0-1.415 0L8 6.585 5.385 4.97a1 1 0 1 0-1.415 1.415L6.585 8l-2.615 2.615a1 1 0 1 0 1.415 1.415L8 9.415l2.615 2.615a1 1 0 0 0 1.415-1.415L9.415 8l2.615-2.615a1 1 0 0 0 0-1.415z"
                clipRule="evenodd"
              />
            </svg>
          )}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            fill="currentColor"
            className="h-5 w-5 text-gray-500 cursor-pointer"
            onClick={handleSearchIconClick}
          >
            <path
              fillRule="evenodd"
              d="M9.965 11.026a5 5 0 1 1 1.06-1.06l2.755 2.754a.75.75 0 1 1-1.06 1.06l-2.755-2.754ZM10.5 7a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
              clipRule="evenodd"
            />
          </svg>


        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="table table-zebra table-sm min-w-[600px] w-full text-[13px]">
          <thead>
            <tr className='text-[13px]'>
              <th className='w-[30px]'>Id</th>
              <th className='p-[5px]'>Име</th>
              <th className='p-[5px]'>Презиме</th>
              <th className='p-[5px]'>Мобилен</th>
              <th className='p-[5px]'>Емаил</th>
              <th className='p-[5px]'>Град</th>
              <th className='p-[5px]'>Улица</th>
              <th className='p-[5px]'>Број</th>
              <th className='p-[5px]'>Поштенски број</th>
            </tr>
          </thead>
          <tbody>
            {customers.map(customer => (
              <tr key={customer.id}>
                <td>{customer.id}</td>
                <td>{customer.firstName}</td>
                <td>{customer.lastName}</td>
                <td>{customer.phoneNumber}</td>
                <td>{customer.emailAddress}</td>
                <td>{customer.city}</td>
                <td>{customer.street}</td>
                <td>{customer.number}</td>
                <td>{customer.postalCode}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {customers.length > 0 && (
          <>
            <div className='text-center'>Тековна страна: {currentPage}</div>
            <div className='text-center'>Вкупно производи: {totalItems}</div>
            <Pagination
              totalPages={totalPages}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            /></>
        )}
      </div>
    </div>
  )
}

export default Customers
